import type { OvpClient } from '@bldsoft/cappie/api/ovp'
import type {
  WebContentFindListResponseOutputDto,
  WebOtherTagFindOneOutputDto,
} from '@bldsoft/ovp-api-types'
import type { API } from '@setplex/tria-api'
import { payload } from '../../result'
import { withTotal } from '../../utils/paginatedList'
import { format as formatContentFromList } from '../content/format'
import { format } from './format'

export type { ApiOtherTag } from './index.h'

export function use(
  client: OvpClient,
  otherTag: API['otherTag'],
  _api: API
): void {
  // GET /api/web/other-tags/${id}/contents
  otherTag.base.getContentFx.use(async ({ id, limit, offset }) => {
    const data = payload<WebContentFindListResponseOutputDto>(
      await client.get.api.web.otherTags(id).contents({
        query: { limit, offset },
      })
    )

    if (!data) {
      throw new Error('Empty answer in otherTag.base.getContentFx')
    }

    const results = [...(data.results || [])].map(formatContentFromList)

    return withTotal(results, data.total)
  })

  // GET /api/web/other-tags/${id}
  otherTag.base.getOneFx.use(
    async ({ id, withContentTypes = 1, withSeoMetadata = 1 }) => {
      const data = payload<WebOtherTagFindOneOutputDto>(
        await client.get.api.web.otherTags(id)({
          query: { withContentTypes, withSeoMetadata },
        })
      )

      if (!data) {
        throw new Error('Empty answer in otherTag.base.getOneFx')
      }

      return format(data)
    }
  )
}
